/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchPreset
 */
export interface SearchPreset {
    /**
     * 
     * @type {string}
     * @memberof SearchPreset
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof SearchPreset
     */
    name: string;
    /**
     * 
     * @type {object}
     * @memberof SearchPreset
     */
    filters: object;
    /**
     * 'user' for user-created, 'system' for auto-generated
     * @type {string}
     * @memberof SearchPreset
     */
    source?: string;
    /**
     * 
     * @type {number}
     * @memberof SearchPreset
     */
    sortOrder?: number;
    /**
     * 
     * @type {Date}
     * @memberof SearchPreset
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SearchPreset
     */
    updatedAt?: Date | null;
}

/**
 * Check if a given object implements the SearchPreset interface.
 */
export function instanceOfSearchPreset(value: object): value is SearchPreset {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('filters' in value) || value['filters'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function SearchPresetFromJSON(json: any): SearchPreset {
    return SearchPresetFromJSONTyped(json, false);
}

export function SearchPresetFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchPreset {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'filters': json['filters'],
        'source': json['source'] == null ? undefined : json['source'],
        'sortOrder': json['sort_order'] == null ? undefined : json['sort_order'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

export function SearchPresetToJSON(json: any): SearchPreset {
    return SearchPresetToJSONTyped(json, false);
}

export function SearchPresetToJSONTyped(value?: SearchPreset | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'filters': value['filters'],
        'source': value['source'],
        'sort_order': value['sortOrder'],
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'] == null ? value['updatedAt'] : value['updatedAt'].toISOString(),
    };
}

